module.exports = __webpack_public_path__ + "static/media/logo.69dca046.png";